import { FC, ReactElement } from 'react';
import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';

import { HeaderNavigationCarousel } from '../headerNavigator/HeaderNavigationCarousel';
import { TableTopResults } from './results/TableTopResults';
import { TableTopCashedMultipliers } from './cashedMultipliersAndWins/TableTopCashedMultipliers';
import { TableTopWins } from './cashedMultipliersAndWins/TableTopWins';

import styles from './TableTopConnected.module.css';

const componentMap: Record<string, ReactElement> = {
  CRASH_CASHED_MULTIPLIERS: <TableTopCashedMultipliers />,
  STATISTICS_WINS: <TableTopWins />,
  STATISTICS_RESULTS_CAPS: <TableTopResults />,
};

export const TableTopConnected: FC = () => {

  return (
    <div className={styles.tableTopContainer}>
      <HeaderNavigationCarousel
        calendarOptions={['STATISTICS_DAY', 'STATISTICS_MONTH', 'STATISTICS_YEAR']}
        tabs={Object.keys(componentMap).map((tab) => ({
          label: <L10nText tk={tab} />,
          content: componentMap[tab],
          key: tab,
        }))}
      />
    </div>
  );
};
